import { createContext } from "react";
import { UserDto } from "../api/identity";

export const UserContext = createContext<AppUser>(null as unknown as AppUser);

export class AppUser {
    constructor(private user: UserDto) {}

    get id(): number {
        return parseInt(String(this.user.id), 10);
    }

    get displayName(): string {
        return String(this.user.displayName ?? "");
    }

    get role(): number {
        return this.user.roleInt;
    }

    hasAccessTo(claimCode: string): boolean {
        if (this.role === 1) {
            return true;
        }

        return this.user.claims.some(
            (c) => c.code.toLowerCase() === claimCode.toLowerCase()
        );
    }
}
